import commonAct from '@/commonActionHandle.js';
import usersList from "@/scripts/users/usersList";
import usersApi from '@/api/common/users';
export default {
    extends: usersList,
    methods: {
        getElementsList(pageNumber) {
            this.showLoading();
            this.$store.dispatch('CANCEL_PENDING_REQUESTS');
            this.elements.data = [];
            let requestParam = Object.assign(this.requestParam, { targetView : this.$route.query.targetView || '', targetRegion : this.$route.query.targetRegion || '' });
            usersApi.getUsersPaid(pageNumber, this.requestParam).then(response => {
                if (response.data && response.data.result === 0 && response.data.data !== null) {
                    this.elements.data = response.data.data.data;
                    this.elements.pagingItem = response.data.data.pagingItem;
                    this.hideLoading();
                }
                else {
                    this.elements.data = [];
                    this.elements.pagingItem = this.defaultPagingItem;
                    this.hideLoading();
                    if (response.data && response.data.message !== null && response.data.message !== '') {
                        commonAct.showError(response.data.message || this.$lang.common.error);
                    }
                }
            }).catch(error => {
                console.error(error);
                this.elements.data = [];
                this.elements.pagingItem = this.defaultPagingItem;
                this.hideLoading();
                commonAct.showError(error);

            });
        },
        exportData() {
            let host = process.env.VUE_APP_API_HOST.slice(0, -1);
            //window.open(host + usersApi.exportUsersPaid(1, this.requestParam), '_blank');
            usersApi.exportUsersPaid(1, this.requestParam).then(response => {
                if (response.data && response.data.result === 0) {
                    this.$message({
                        message: 'Congrats, perform action succeed.',
                        type: 'success'
                    });
                }
            }).catch(error => {
                console.error(error);
            });
        },
    }
}